import { AfterViewInit, Component, ElementRef, Input, Renderer2, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-scroll-wrapper',
    templateUrl: './scroll-wrapper.component.html',
    styleUrls: ['./scroll-wrapper.component.scss'],
    standalone: true,
    imports: [MatIconModule]
})
export class ScrollWrapperComponent implements AfterViewInit {
    @ViewChild('scrollContainer', { static: true }) scrollContainer!: ElementRef<HTMLElement>;
    @Input() classes: string[];
    @Input() styles: { [key: string]: string };
    @Input() enableScrollListener: boolean;

    showLeft = false;
    showRight = true;

    constructor(private renderer: Renderer2) {}

    ngAfterViewInit() {
        if (this.classes) {
            this.classes.forEach(cls => {
                this.renderer.addClass(this.scrollContainer.nativeElement, cls);
            });
        }

        this.updateArrowVisibility();
    }

    scrollLeft() {
        const container = this.scrollContainer.nativeElement;
        const items = Array.from(container.querySelectorAll('[scroll-item]')) as HTMLElement[];

        for (let i = items.length - 1; i >= 0; i--) {
            const item = items[i];
            if (item.offsetLeft < container.scrollLeft) {
                container.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
                break;
            }
        }
    }

    scrollRight() {
        const container = this.scrollContainer.nativeElement;
        const items = Array.from(container.querySelectorAll('[scroll-item]')) as HTMLElement[];

        const containerScrollLeft = container.scrollLeft;
        //   const containerRightEdge = containerScrollLeft + container.clientWidth;

        for (let item of items) {
            const itemLeft = item.offsetLeft;

            if (itemLeft > containerScrollLeft) {
                container.scrollTo({ left: itemLeft, behavior: 'smooth' });
                break;
            }
        }
    }

    updateArrowVisibility() {
        if (this.enableScrollListener) {
            const el = this.scrollContainer.nativeElement;
            this.showLeft = el.scrollLeft > 0;
            this.showRight = el.scrollLeft + el.clientWidth < el.scrollWidth - 1;
        }
    }
}
